<template>
  <v-data-table
    :headers="ei_headers"
    :items="ei_items"
    class="elevation-1 mt-3"
    :loading="eiLoading"
    loading-text="Загружаю данные"
    item-key="EI_ID"
    :search="eiSearch"
    show-select
    single-select
    locale="ru-RU"
    dense
    :value="value"
    @input="setValue"
  >
    <template v-slot:top>
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title>Пользовательские единицы измерения</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="eiSearch"
          append-icon="mdi-magnify"
          label="Искать"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-btn icon @click="$emit('onCloseWindow', true)" v-if="mode == 'compact'">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      Нет данных
    </template>
  </v-data-table>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'

export default {
  name: 'MULocalTable',
  props: ['value', 'mode'],
  data () {
    return {
      ei_headers: [
        { text: 'Наименование', value: 'EI_NAME' },
        { text: 'Код единицы', value: 'EI_CODE' }
      ],
      eiLoading: false,
      eiSearch: '',
      ei_items: []
    }
  },

  computed: {},
  watch: {
    value (val) {
      if (!val || !val.length || !val[0].EI_ID) return
      const curr = this.ei_items.findIndex(itm => itm.EI_ID === val[0].EI_ID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.ei_items.splice(curr, 1)
          this.setValue([])
          return
        }
        this.ei_items.splice(curr, 1, val[0])
      } else {
        this.ei_items.push(val[0])
      }
    }
  },

  mounted: function () {
    if (this.ei_items.length === 0) {
      this.getEIList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getEIList () {
      const self = this
      this.eiLoading = true
      axios({
        url: '/api/org/references/getMUList.php',
        method: 'POST'
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.ei_items.splice(0, self.ei_items.length, ...resp.data.data)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка единиц измерения: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения единиц измерения: \n ${err}` })
        })
        .finally(
          this.eiLoading = false
        )
    }
  }
}

</script>
